module.exports = __webpack_public_path__ + "static/3-6e03f956fafbeea8d8710e1f2d1d863a.png";